(function ($) {
	'use strict';
	
	/*------------------------------------*\
		Slick (Gallery)
	\*------------------------------------*/
	var $slickGallery = $('#slickGallery');
	var $galleryCtrl = $('.gallery-ctrl');
	var $pictureInfos = $('.picture-info');

	$slickGallery.slick({
		accessibility: false,
		appendDots: $galleryCtrl,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 8000,
		dots: true,
		fade: true,
		speed: 1000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					autoplay: false
				}
			}
		]
	});

	$slickGallery.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
		$pictureInfos.removeClass('viewed');
		$pictureInfos.eq(nextSlide).addClass('viewed');
	});

	/*------------------------------------*\
		Contact Form
	\*------------------------------------*/
	// var $contactForm = $('#contactForm');
	// var $errorFeed = $('.errorFeed');
	// var $inputs = $('#contactForm input');
	var $hasPlaceholders = $('.hasPlaceholder');
	// var $subbmitButton = $('[type="submit"]');
	// var $sentFeed = $('.sentFeed');
	// var $sentFeedCloseBtn = $('.sentFeedCloseBtn');

	// var submitValue = $subbmitButton.val();

	// Placeholder Animation
	// Keyup
	$hasPlaceholders.on('keyup', function (e) {
		var $target = $(e.target);
		var $parent = $target.parent();

		// Add/remove class from parent
		if ( $target.val() ) {
			$parent.addClass('hasValue');
		} else {
			$parent.removeClass('hasValue');
		}
	});

	// Onfocus
	$hasPlaceholders.on('focus', function(e) {
		$(e.target).parent().addClass('onFocus');
	});

	// Onfocusout
	$hasPlaceholders.on('focusout', function(e) {
		$(e.target).parent().removeClass('onFocus');
	});

	/*------------------------------------*\
		Email Decryption
	\*------------------------------------*/
	// Email obfuscator script 2.1 by Tim Williams, University of Arizona
	// Random encryption key feature coded by Andrew Moulden
	// This code is freeware provided these four comment lines remain intact
	// A wizard to generate this code is at http://www.jottings.com/obfuscator/
	var $emailCell =  $('#email');
	var coded = "qvXlgOg2P@R4wPc.3v4";
	var key = "TvZlM1tSaIgjPLqe0GOxb6c78QCwrRyF5Y9fBnVHm3EKoWz2NAUdDusiXhp4Jk";
	var shift = coded.length;
	var link = "";

	for (var i=0; i<coded.length; i++) {
		if (key.indexOf(coded.charAt(i))==-1) {
			var ltr = coded.charAt(i)
			link += (ltr)
		}
		else {
			var ltr = (key.indexOf(coded.charAt(i))-shift+key.length) % key.length
			link += (key.charAt(ltr))
		}
	}

	$emailCell.html("<a class='email-link' href='mailto:"+link+"'>"+link+"</a>");

	/*------------------------------------*\
		Scroll Animation
	\*------------------------------------*/

	var windowHeight, inViewOffset;
	var $window = $(window);
	var $animationElements = $('[data-animation]');
	var animationArray = [];

	function AnimationElement (element) {
		this.el = element,
		this.offsetTop = 0,
		this.inViewScrollTop = 0,
		this.addingClass;
	}

	function animationUpdatePosition () {
		windowHeight = $window.height(),
		inViewOffset = windowHeight * .25;

		$(animationArray).each(function () {
			var $el = $(this.el);
			var type = $el.data('animation');

			this.offsetTop = $el.offset().top;
			this.inViewScrollTop = this.offsetTop - windowHeight + inViewOffset;
			this.addingClass = type ? type : 'slideInUp';
		});

		// Trigger 'scroll' so that the change to be affected.
		$window.trigger('scroll');
	}

	function animation () {
		var scrollTop = $window.scrollTop();

		$(animationArray).each( function () {
			if ( scrollTop >= this.inViewScrollTop) {
				$(this.el).addClass(this.addingClass);
			}
		});
	}

	// Create an array holding all animation elements
	$animationElements.each(function () {
		var obj = new AnimationElement(this);
		animationArray.push( obj );
	});

	$window.on('load', function () {
		animationUpdatePosition();

		// Set scroll event.
		$window.on('scroll', animation);
		$window.trigger('scroll');

	});
	
})(jQuery3);